import { combineReducers } from 'redux';

import plays from './reducers/plays';

export default combineReducers({
  plays
});



// WEBPACK FOOTER //
// ./src/rootReducer.js